import MhBotInfo from './MhBotInfo'

export default MhBotInfo
